import { Container } from './styles';

export function VendorsDashboard() {
  return (
    <Container>
      <h1>VendorsDashboard</h1>
    </Container>
  );
};
